import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonSmallTitle from '../../../common-components/common-small-title';

const taskPointList = [
    {
        img: '/images/svg/gge/gge-tasks__item-1.svg',
        title: 'Модернизация и поддержка официального сайта ФАУ «Главгосэкспертиза России»',
        text: 'Необходимо было перенести проект на новый сервер, создать новые и доработать старые функции для удобства пользователей, защитить формы капчей и исправить ошибки. В результате сайт должен предоставлять посетителям необходимую информацию о деятельности учреждения, а также доступ ко всем услугам и сервисам для физических и юридических лиц.',
    },
];

const Task = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} caseName="gge-tasks">
                <div className="gge-tasks__wrapper">
                    <div className="gge-tasks__grid">
                        <div className="gge-tasks__info">
                            <CommonTitle className="gge-tasks__title">Задачи</CommonTitle>
                            <CommonUsualText>
                                <div className="gge-tasks__subtitle" href="#">
                                    Перед нами стояли две важные задачи, которые необходимо было
                                    выполнить.
                                </div>
                            </CommonUsualText>
                        </div>
                        <div className="gge-tasks__points">
                            {taskPointList.map(({ img, title, text }, index) => (
                                <ScrollAnimation
                                    animateIn="fadeIn"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                    className="gge-tasks__point-item"
                                    key={index}
                                >
                                    <div className="gge-tasks__point-title">
                                        <img
                                            className="gge-tasks__point-img"
                                            src={img}
                                            alt=""
                                            loading="lazy"
                                        />
                                        <CommonSmallTitle>{parse(title)}</CommonSmallTitle>
                                    </div>
                                    <CommonSmallText className="gge-tasks__point-text">
                                        {parse(text)}
                                    </CommonSmallText>
                                </ScrollAnimation>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Task;
